import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  FormInput,
} from '@kirz/mui-admin';
import React, {
  forwardRef,
  Ref,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const TagsTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'id',
            headerName: 'ID',
            width: 60,
            sortable: false,
          },
          {
            field: 'name',
            selector: 'name',
            headerName: 'Название',
            flex: 1,
          },
          { field: 'createdAt', headerName: 'Дата создания', type: 'date' },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="tag"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        formTitle={(isNew) => (isNew ? 'Новый тег' : 'Редактировать тег')}
        formDialogProps={{
          ...rest.formDialogProps,
          maxWidth: 'xs',
        }}
      >
        <FormInput name="name" label="Название" required />
      </DataTableEx>
    );
  },
);
